import cartSummaryHtml from './cartsummary.component.html';
import './cartsummary.component.scss';

class CartSummaryController {
    constructor($scope, CartService, SnackbarService, ModalService) {
        'ngInject';

        this.$scope = $scope;
        this.service = CartService;
        this.SnackbarService = SnackbarService;
        this.ModalService = ModalService;

        this.showDiscount = false;
        this.discountCode = '';
        this.discountLoading = false;
        this.discountCodeHasError = false;
    }

    $onInit() {
        if (!this.service.loaded && !this.service.loading) {
            this.service.load();
        }

        this.waitForElm('.toggle-discount').then(el => {
            angular.element(el).on('click', () => {
                this.toggleDiscountCodeList('cats-wrapper');
            })
        });

        this.waitForElm('.toggle-producers').then(el => {
            angular.element(el).on('click', () => {
                this.toggleDiscountCodeList('producers-wrapper');
            })
        });


        this.$scope.$watch(
            () => this.discountCode,
            () => {
                this.discountCodeHasError = false;
            }
        );
    }

    toggleDiscountCodeList(className) {
        const wrapperElm = document.getElementsByClassName(className)[0];
        if (wrapperElm.classList.contains('folded')) {
            wrapperElm.classList.remove('folded');
        } else {
            wrapperElm.classList.add('folded');
        }
    }

    waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });

            // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    addDiscountCode() {
        if (this.discountCode.length < 1) {
            this.SnackbarService.add('Kod rabatowy nie może być pusty!', 'error', true, 2000);
            return;
        }

        this.service.addDiscountCode(this.discountCode).then(
            () => {
                this.showDiscount = false;
                this.discountCode = '';
                this.discountLoading = false;

                this.SnackbarService.add('Dodano kod rabatowy.', 'success', true, 2000);
            },
            () => {
                this.discountLoading = false;
                this.discountCodeHasError = true;
            }
        );

        this.discountLoading = true;
    }

    removeDiscountCode(discountCode) {
        this.discountLoading = true;

        this.service.removeDiscountCode(discountCode).then(
            () => {
                this.discountLoading = false;

                this.SnackbarService.add('Usunięto aktywny kod rabatowy.', 'success', true, 2000);
            },
            () => {
                this.discountLoading = false;
            }
        );
    }

    openHowToGetDiscountCodeModal() {
        const modalRef = this.ModalService.add(
            'JAK ZDOBYĆ KOD RABATOWY?',
            `<p>Obserwuj nas w mediach społecznościowych:<br>
                <svg width="19" height="19" style="margin-bottom: 2px; margin-right: 5px;">
                    <use xlink:href="/templates/rowerystylowenew/dist/spritemap.svg?v=202406200#sprite-facebook-icon"></use>
                </svg> Facebook: <a href="https://www.facebook.com/rowerystylowepl/" target="_blank">https://www.facebook.com/rowerystylowepl/</a><br>
                <svg width="19" height="19" style="margin-bottom: 2px; margin-right: 5px;">
                    <use xlink:href="/templates/rowerystylowenew/dist/spritemap.svg?v=202406200#sprite-instagram-icon"></use>
                </svg> Instagram: <a href="https://www.instagram.com/rowerystylowe.pl/" target="_blank">https://www.instagram.com/rowerystylowe.pl/</a></p>
            <p>Organizujemy tam czasami akcje promocyjne gdzie można zdobyć <strong>KOD RABATOWY</strong></p>
            <p>Możesz też zapisać się do Newslettera za co my odwdzięczymy się jednorazowym <strong>KODEM RABATOWYM</strong> o wysokości 20pln</p>`
        );

        modalRef.open();
    }
}

let cartSummaryComponent = {
    bindings: {},
    template: cartSummaryHtml,
    controller: CartSummaryController
}

export default cartSummaryComponent;
